import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN, USER_ID, IS_SOTRAVEL_ADMIN } from 'constants/AuthConstant';
import AuthService from 'services/AuthService';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';

export const initialState = {
  loading: false,
  redirect: '',
  token: localStorage.getItem(AUTH_TOKEN) || null,
};

export const signIn = createAsyncThunk(
  'auth/signIn',
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthService.signInWithOTP(data);
      localStorage.setItem(AUTH_TOKEN, response.token);
      localStorage.setItem(USER_ID, response.user.id);
      if (response.user.is_admin) {
        localStorage.setItem(IS_SOTRAVEL_ADMIN, 'true');
      }
      return response.token;
    } catch (err) {
      // Give callers a structured payload so they can render inline errors
      // (401 = wrong OTP, 403 = NOT_MERCHANT_PORTAL_USER, etc.).
      return rejectWithValue({
        status: err?.response?.status,
        message: err?.response?.data?.message,
        code: err?.response?.data?.code,
      });
    }
  }
);

export const signOut = createAsyncThunk('auth/signOut', async () => {
  localStorage.removeItem(AUTH_TOKEN);
  return;
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = '/';
      state.token = action.payload;
    },
    signOutSuccess: (state) => {
      state.loading = false;
      state.token = null;
      state.redirect = '/';
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = AUTHENTICATED_ENTRY;
        state.token = action.payload;
      })
      .addCase(signIn.rejected, (state) => {
        state.loading = false;
      })
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = '/';
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = '/';
      });
  },
});

export const { authenticated, signOutSuccess, showLoading, signInSuccess } =
  authSlice.actions;

export default authSlice.reducer;
